export default __webpack_public_path__ + "static/media/3.bc2ba5e3.jpeg";